import { combineReducers } from 'redux';
import initialState from '~scenes/madeforyou/app/store/initialState';
import {
    MADE_FOR_YOU_LOADING,
    MADE_FOR_YOU_LOADING_SUCCESS,
    MADE_FOR_YOU_LOADING_ERROR,
    MADE_FOR_YOU_CLEAR_BETCARDS,
    MADE_FOR_YOU_SET_ACTIVE_TAB,
    MADE_FOR_YOU_PUSH_ACTIVE_TAB,
    MADE_FOR_YOU_SET_TAB_LIST,
    MADE_FOR_YOU_SET_IS_WIDGET,
    MADE_FOR_YOU_REMOVE_BET_CARD,
    MADE_FOR_YOU_SET_CURRENT_PAGE,
    MADE_FOR_YOU_INCREASE_CURRENT_PAGE,
    MADE_FOR_YOU_DECREASE_CURRENT_PAGE,
    MADE_FOR_YOU_INIT,
} from './../actions/mfyActionTypes';
import commonStoreReducer from '../../../../shared/components/react/CommonDataStore/reducer';
import tabsReducer from './tabsReducer';

/**
 * Main made for you reducer
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
export function mfyReducer(state = initialState, action) {
    switch (action.type) {
        case MADE_FOR_YOU_INIT: {
            return {
                ...initialState,
                isMadeForYouWidget: action.isWidget,
            };
        }
        case MADE_FOR_YOU_LOADING: {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.betCardType]: action.status,
                },
            };
        }
        case MADE_FOR_YOU_LOADING_SUCCESS: {
            return {
                ...state,
                activeTab: action.betCardType,
                betCards: action.data.betcards,
            };
        }
        case MADE_FOR_YOU_LOADING_ERROR: {
            return {
                ...state,
                isError: {
                    ...state.isError,
                    [action.betCardType]: action.isError,
                },
                betCards: [],
            };
        }
        case MADE_FOR_YOU_CLEAR_BETCARDS: {
            return {
                ...state,
                betCards: [],
            };
        }
        case MADE_FOR_YOU_SET_ACTIVE_TAB:
        case MADE_FOR_YOU_PUSH_ACTIVE_TAB:
        case MADE_FOR_YOU_SET_TAB_LIST: {
            return tabsReducer(state, action);
        }
        case MADE_FOR_YOU_SET_IS_WIDGET: {
            return {
                ...state,
                isMadeForYouWidget: action.isMadeForYouWidget,
            };
        }
        case MADE_FOR_YOU_REMOVE_BET_CARD: {
            return {
                ...state,
                betCards: state.betCards.filter(({betcard_id}) => betcard_id !== action.betcardId),
            };
        }
        case MADE_FOR_YOU_SET_CURRENT_PAGE: {

            return {
                ...state,
                currentPage: action.pageNumber,
            };
        }
        case MADE_FOR_YOU_INCREASE_CURRENT_PAGE: {

            return {
                ...state,
                currentPage: state.currentPage + 1,
            };
        }
        case MADE_FOR_YOU_DECREASE_CURRENT_PAGE: {

            return {
                ...state,
                currentPage: state.currentPage - 1,
            };
        }
        default:
            return state;
    }
}

export default combineReducers({
    commonData: commonStoreReducer,
    mfyData: mfyReducer,
});
